import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import type { TerminalVersionList } from "src/app/features/TerminalVersion/types/TerminalVersionList";
import { PrimaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";

export const AddCampaignButton: FC<ButtonProps<TerminalVersionList>> = ({ items }) => {
    const navigate = useNavigate();

    const callback = () => {
        const getSelectedSiteIds = () => (items ? Array.from(new Set(items.map((item) => item.siteId))) : []);
        const getSelectedTerminalIds = () => (items ? Array.from(new Set(items.map((item) => item.terminalId))) : []);

        navigate(`${BASE_PATH}/${ResourceName.CAMPAIGNS}/${ResourceVariant.ORG_UNITS}/${FORM_ACTION.CREATE}`, {
            state: { terminalIds: getSelectedTerminalIds(), siteIds: getSelectedSiteIds() },
        });
    };

    let disabled = false;
    if (items) {
        disabled = items.length === 0;
    }

    return (
        <PrimaryButton name="addCampaign_button" onClick={callback} disabled={disabled}>
            {i18n.t("button.addCampaignOrgUnit")}
        </PrimaryButton>
    );
};
